import { IExportArtifact } from "../../domain/ExportArtifacts/IExportArtifact";
import { IExportArtifactRepository } from "../../domain/ExportArtifacts/IExportArtifactRepository";
import { localDb } from "./LocalDb";

export class ExportArtifactRepository implements IExportArtifactRepository {
    get(): Promise<IExportArtifact[]> {
        return localDb.exportArtifact.toArray();
    }
    getById(id: string): Promise<IExportArtifact | undefined> {
        return localDb.exportArtifact.where("id").equals(id).first();
    }
    async save(items: IExportArtifact[]): Promise<void> {
        await localDb.exportArtifact.bulkPut(items);
    }
    async delete(id: string): Promise<void> {
        await localDb.exportArtifact.delete(id);
    }
}
